// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__TKFFb","scroller":"index_scroller__s9U2P","track-y-props":"index_track-y-props__HmF05","thumb-y-props":"index_thumb-y-props__TT82l"};